module.exports = __webpack_public_path__ + "static/media/jumbled-words-moon.e02a2c5f.svg";